export default __webpack_public_path__ + "static/media/pawprint.482af8fa.svg";